import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorTextMedium, space1 } = theme();

  return StyleSheet.create({
    container: {
      flexDirection: "column",
      flex: 1,
      gap: space1,
      justifyContent: "space-between",
    },
    title: {
      color: colorTextMedium,
    },
  });
};

export { style };
